/* exported imageTransitionIn */

if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i); // preallocate the Array

    // eslint-disable-next-line no-plusplus
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
}

var mediaTypeMappings = {
  text: 'Text',
  image: 'Image',
  audio: 'Audio',
  video: 'Video',
  pdf: 'Text',
  document: 'Text',
  speadsheet: 'Text',
  csv: 'Text',
};

function imageTransitionIn(event, scrollTop, pending) {
  if (pending == null) {
    pending = false;
  }

  if (!pending) {
    $(event)
      .closest('.chat-well')
      .find('.progress')
      .slideUp(function () {
        $(event)
          .closest('.chat-well')
          .find('.mms-media-image')
          .slideDown(function () {
            if (scrollTop === true) {
              var chatMessage = $(event).closest('.chat-messages');

              $(chatMessage).animate({ scrollTop: chatMessage.scrollTop() + 150 }, 0);
            }
          });
      });
  } else {
    // if message is pending, load up the mms media message instead of just regular chat message
    $(event)
      .closest('.chat-well')
      .find('.mms-media-image')
      .slideDown(function () {
        if (scrollTop === true) {
          // $chatMessages.scrollTop($chatMessages[0].scrollHeight);
          var chatMessage = $(event).closest('.chat-messages');

          $(chatMessage).animate({ scrollTop: chatMessage.scrollTop() + 150 }, 0);
        }
      });
  }
}

function buildMediaFailedAlert() {
  return '<div class="alert alert-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Failed to load media!</div>';
}

function buildBadge(typeLabel, sizeLabel, supported) {
  var badgeRole = supported ? 'info' : 'important';

  return '<div class="label label-pill label-' + badgeRole + '">' + _('Media') + ' - ' + typeLabel + ' (' + sizeLabel + ')</div>';
}

function buildMediaNotSupportedAlert(mediaTypeLabel, mediaSizeLabel) {
  return '<div class="alert alert-danger">'
    + '  <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>'
    + ' ' + _('Media not supported') + '!<br />'
    + buildBadge(mediaTypeLabel, mediaSizeLabel, false)
    + '</div>';
}

function getMediaType(type) {
  var typeParts = type.split('/');
  var mimeType = typeParts[0];
  var mediaType = typeParts[1];

  if (mimeType === 'image') {
    return mediaTypeMappings.image;
  }

  if (mimeType === 'audio') {
    return mediaTypeMappings.audio;
  }

  if (mimeType === 'video') {
    return mediaTypeMappings.video;
  }

  if (mimeType === 'application' && mediaType === 'pdf') {
    return mediaTypeMappings.pdf;
  }

  if (mimeType === 'application' && mediaType.includes('officedocument')) {
    return mediaTypeMappings.document;
  }

  if (mimeType === 'text' && mediaType === 'plain') {
    return mediaTypeMappings.csv;
  }

  return 'Unknown';
}

function formatSizeUnits(bytes) {
  if (bytes >= 1073741824) {
    bytes = Math.round(bytes / 1073741824) + 'GB';
  } else if (bytes >= 1048576) {
    bytes = Math.round(bytes / 1048576) + 'MB';
  } else if (bytes >= 1024) {
    bytes = Math.round(bytes / 1024) + 'KB';
  } else if (bytes > 1) {
    bytes += ' bytes';
  } else if (bytes == 1) {
    bytes += ' byte';
  } else {
    bytes = '0 bytes';
  }

  return bytes;
}

function buildMmsMediaMessage(
  mediaType,
  mediaSize,
  messageId,
  scrollTop,
  remotePath,
  direction,
  sessionId,
  message
) {
  if (remotePath == undefined) {
    remotePath = null;
  }

  if (direction == undefined) {
    direction = null;
  }

  if (sessionId == undefined) {
    sessionId = null;
  }

  if (message == undefined) {
    message = null;
  }

  var mediaTypeLabel = getMediaType(mediaType);
  var mediaSizeLabel = formatSizeUnits(mediaSize);
  var mediaSrc = '/portal/messages/media/' + messageId + '/' + sessionId;

  if (remotePath !== null) {
    mediaSrc = remotePath;
  }

  var tag = '<div>';

  if (mediaTypeLabel == 'Image') {
    tag += '<div class="progress progress-striped active">'
      + '  <div class="bar" style="width: 100%;"></div>'
      + '</div>';
  }

  if (mediaTypeLabel == 'Image') {
    tag += '<div class="mms-media-image"><img src="' + mediaSrc + '" onerror="this.onerror=null;displayFileError(this)" onload="imageTransitionIn(this, ' + scrollTop + ')" onclick="showMmsFullImage(this)" /></div>';
  } else if (mediaTypeLabel == 'Video') {
    tag += '<div><video style="max-width: 100%;" controls controlslist="nodownload"><source src="' + mediaSrc + '" onerror="this.onerror=null;displayFileError(this)" onload="imageTransitionIn(this, ' + scrollTop + ')" onclick="showMmsFullImage(this)"></video></div>';
  } else if (mediaTypeLabel == 'Audio') {
    tag += '<div><audio class="mms-media-audio" style="max-width: 100%;" controls controlslist="nodownload" src="' + mediaSrc + '"><track kind="captions"/></audio></div>';
  } else if (mediaTypeLabel == 'Text') {
    tag += '<div><a class="mms-media-text" style="max-width: 100%;" href="' + mediaSrc + '" download="' + message + '">' + message + '</a></div>';
  } else {
    // TODO add PDF and other file types
    tag += buildMediaNotSupportedAlert(mediaTypeLabel, mediaSizeLabel);
  }

  tag += '</div>';

  return tag;
}

function mmsMediaMessage(elem) {
  var tag = buildMmsMediaMessage(
    $(elem).data('contentType'),
    $(elem).data('contentLength'),
    $(elem).data('messageId'),
    false,
    $(elem).data('remotepath'),
  );

  $(elem).html(tag);
}

function displayMedia() {
  var media = document.getElementsByClassName('mms-media');

  Object.entries(media)
    .map(function (elem) {
      elem = elem[1];

      return mmsMediaMessage(elem);
    });
}

function displayFileError(e) {
  log('displayFileError', $(e).parent());

  $(e)
    .off('error')
    .hide();

  // hide progress bar if failed to load
  $(e).parent()
    .parent()
    .find('.progress')
    .hide();

  $(e)
    .parent()
    .append(buildMediaFailedAlert())
    .fadeIn();
}

function showMmsFullImage(e) {
  var stopPropagation = function (e) {
    e.stopPropagation();
  };

  var btnBase = function (title) {
    return '<button class="btn btn-inverse" title="' + title + '">';
  };

  var progress = $('<div class="progress progress-info progress-striped active">\n'
    + '  <div class="bar" style="width: 100%"></div>\n'
    + '</div>');

  var image = $(e)
    .clone()
    .hide()
    .on('load', function () {
      var imageElem = $(this);

      $('.mms-lightbox-image')
        .find('.progress')
        .fadeOut(200, function () {
          $('body').addClass('mms-no-scroll');
          imageElem.fadeIn(800);
        });
    })
    .removeAttr('onclick')
    .on('click', stopPropagation);

  var btnDownload = $(btnBase('Download Media')
    + '<a href="' + image.attr('src') + '" download><i class="fa fa-download fa-3x" aria-hidden="true" style="color: #fff !important;">')
    .on('click', stopPropagation);

  var btnExternalWindow = $(btnBase('Open in new Window')
    + '<a href="' + image.attr('src') + '" target="_blank"><i class="fa fa-external-link fa-3x" aria-hidden="true" style="color: #fff !important;">')
    .on('click', stopPropagation);

  var lightBox = $('<div class="mms-lightbox-container" onclick="hideMmsFullImage(this)"><div class="mms-lightbox-image"></div></div>');
  var lightBoxControls = $('<div class="mms-lightbox-controls" />')
    .append($(btnBase('Close')
      + '<i class="fa fa-times fa-3x" aria-hidden="true" />'))
    .append(btnDownload)
    .append(btnExternalWindow);

  lightBox
    .find('.mms-lightbox-image')
    .append(progress)
    .append(image)
    .append(lightBoxControls);

  $('.page-container').prepend(lightBox);
  $('.btn-tooltip').tooltip();

  console.log(e, lightBox);
}

function hideMmsFullImage(e) {
  $(e).fadeOut(1000, function () {
    $('body').removeClass('mms-no-scroll');
    $(e).remove();
  });
}

(function () {
  var startup = function () {
    displayMedia();
  };

  window.addEventListener('load', startup, false);
}());
